/* Belle Luce – compteur du diagnostic de peau
   Envoie 4 événements : diagnostic_demarre, diagnostic_questions_finies,
   diagnostic_email_envoye, diagnostic_resultat_vu.
   - Shopify (événements clients) : Shopify.analytics.publish
   - Meta : fbq('trackCustom') si le pixel est présent sur la page
   Chaque événement n'est compté qu'une fois par visite. */
(function(){
  var root=document.getElementById('diagnostic'); if(!root) return;
  var page=(window.location.pathname.indexOf('diagnostic')>-1)?'page-diagnostic':'accueil';

  function once(name){
    var k='blq-ev-'+name;
    try{ if(sessionStorage.getItem(k)) return false; sessionStorage.setItem(k,'1'); }catch(e){}
    return true;
  }
  function track(name,extra){
    if(!once(name)) return;
    var data={emplacement:page}; for(var x in (extra||{})) data[x]=extra[x];
    try{ if(window.Shopify&&Shopify.analytics&&Shopify.analytics.publish) Shopify.analytics.publish(name,data); }catch(e){}
    try{ if(typeof window.fbq==='function') window.fbq('trackCustom',name,data); }catch(e){}
  }

  root.addEventListener('click',function(e){
    var a=e.target.closest('[data-act="start"]'); if(a) track('diagnostic_demarre');
  });

  var form=root.querySelector('#blq-form');
  if(form) form.addEventListener('submit',function(){
    var t=(root.querySelector('#blq-tags')||{}).value||'', m=t.match(/profil-([a-z]+)/);
    track('diagnostic_email_envoye',{profil:m?m[1]:''});
  });

  function watch(step,name){
    var el=root.querySelector('[data-step="'+step+'"]'); if(!el) return;
    function check(){ if(!el.hidden) track(name); }
    new MutationObserver(check).observe(el,{attributes:true,attributeFilter:['hidden']});
    check();
  }
  watch('gate','diagnostic_questions_finies');
  watch('result','diagnostic_resultat_vu');
})();
